import { repository } from "~/repository";
import type { Collection } from "~/types";
import { useAuthStore } from "~/stores/auth/store";
import { includes } from "lodash-es";

export default function (collection: Collection) {
  const toast = useToast();

  const authStore = useAuthStore();
  const { authenticated } = storeToRefs(authStore);

  const isFavorite = ref<boolean>(collection.favorite);
  const isFavoriteLoading = ref<boolean>(false);

  const favoriteTooltip = computed(() => {
    return isFavorite.value ? "Remove from favorites" : "Add to favorites";
  });

  const favoriteIcon = computed(() => {
    return isFavorite.value ? ["fas", "minus"] : ["fas", "plus"];
  });

  async function toggleFavorites() {
    isFavoriteLoading.value = true;
    const payload = {
      type: includes(["collection", "playlist"], collection.type)
        ? "collections"
        : "videos",
      id: collection.id,
    };
    if (isFavorite.value) {
      await repository.common.removeFromFavorites(payload);
      isFavorite.value = false;

      toast.add({
        severity: "success",
        summary: "Removed from Favorites!",
        detail: `${collection.title} was successfully removed from your favorites !`,
        life: 3000,
      });
    } else {
      await repository.common.addToFavorites(payload);
      isFavorite.value = true;

      toast.add({
        severity: "success",
        summary: "Added to Favorites!",
        detail: `${collection.title} was successfully added to your favorites !`,
        life: 3000,
      });
    }
    isFavoriteLoading.value = false;
  }

  return {
    favoriteVisible: authenticated.value,
    isFavorite,
    toggleFavorites,
    isFavoriteLoading,
    favoriteTooltip,
    favoriteIcon,
  };
}
